export const types = {
  LOAD_SIMULATION_JOB: "LOAD_SIMULATION_JOB",
};
